import { DrawerProps } from '@components/Drawer/next';
import { CustomIcon } from '@components/Dropdown/styled';
import { CloseIcon, SeturLogo } from '@assets/icons';
import { StyledDrawer } from '@components/views/components/listing/ResponsiveListingSearchStyle';

const ResponsiveDrawer = ({
  visible,
  onClose,
  title = <CustomIcon icon={SeturLogo} width={80} height={40} />,
  children,
  booker,
  ...otherProps
}: DrawerProps) => {
  return (
    <StyledDrawer
      title={title}
      booker={booker}
      closeIcon={
        <CustomIcon icon={CloseIcon} fontSize={24} paletteColor='black' />
      }
      placement='top'
      onClose={onClose}
      visible={visible}
      {...otherProps}
    >
      {children}
    </StyledDrawer>
  );
};

export default ResponsiveDrawer;
